module.exports = __webpack_public_path__ + "img/i-members-admin.492496c7.svg";